import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class CurrencyComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentCurrency | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.conditional = settings?.conditional ?? {
			eq: '',
			show: undefined,
			when: undefined,
		};
		this.decimalLimit = settings?.decimalLimit ?? 2;
		this.defaultValue = settings?.defaultValue ?? null;
		this.delimiter = settings?.delimiter ?? true;
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputType = settings?.inputType ?? 'text';
		this.inputMask = settings?.inputMask ?? '';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.requireDecimal = settings?.requireDecimal ?? true;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom,
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
